/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_PartialInputs */

const cs_enum_partial = /** @type {(inputs: Enum_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Částečně`)
};

const en_enum_partial = /** @type {(inputs: Enum_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partial`)
};

/**
* | output |
* | --- |
* | "Partial" |
*
* @param {Enum_PartialInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_partial = /** @type {((inputs?: Enum_PartialInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_PartialInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_partial(inputs)
	return cs_enum_partial(inputs)
});